'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {Label, DropdownButton, MenuItem} from 'react-bootstrap';
// import moment from 'moment';
// import {getCameraDetails} from '../../utils/kunaUtils';

// const defaultDeleteText = 'Delete';

var CameraDetail = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CameraDetail, _Component);

  function CameraDetail(props) {
    (0, _classCallCheck3.default)(this, CameraDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CameraDetail.__proto__ || (0, _getPrototypeOf2.default)(CameraDetail)).call(this, props));

    _this.state = {
      // showDeleteTooltip: false,
      // deleteTarget: null,
      // deleteTextToUser: defaultDeleteText,
    };
    return _this;
  }

  (0, _createClass3.default)(CameraDetail, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.onUpdate) {
        this.props.onUpdate();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      // const {
      //   // camera,
      //   // email,
      //   // customerName,
      //   // zdTicketUrl,
      //   // onPlan,
      //   // timezone,
      //   // shared,
      //   // slackDeleteURI,
      //   // RMAUrl,
      //   // returnUrl,
      //   // djangoUrl,
      //   // logglyUrls,
      //   // deleteUrl,
      //   // deleteText,
      //   // firmwareModel,
      //   // upToDateFW,
      //   // isFwUpToDate,
      //   // isBetaFW,
      // } = this.props;

      return _react2.default.createElement('div', null);
    }
  }]);
  return CameraDetail;
}(_react.Component), _class.propTypes = {
  camera: _react.PropTypes.object,
  email: _react.PropTypes.string,
  customerName: _react.PropTypes.string,
  zdTicketUrl: _react.PropTypes.string,
  onPlan: _react.PropTypes.bool,
  timezone: _react.PropTypes.string,
  shared: _react.PropTypes.bool,
  slackDeleteURI: _react.PropTypes.string,
  RMAUrl: _react.PropTypes.string,
  returnUrl: _react.PropTypes.string,
  djangoUrl: _react.PropTypes.string,
  logglyUrl: _react.PropTypes.string,
  logglyUrls: _react.PropTypes.array,
  deleteUrl: _react.PropTypes.string,
  deleteText: _react.PropTypes.string,
  firmwareModel: _react.PropTypes.string,
  upToDateFW: _react.PropTypes.number,
  isFwUpToDate: _react.PropTypes.bool,
  isBetaFW: _react.PropTypes.bool,
  firmware: _react.PropTypes.object,
  onUpdate: _react.PropTypes.func
}, _temp);
exports.default = CameraDetail;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CameraDetail/CameraDetail.js
 ** module id = 1379
 ** module chunks = 0
 **/